import { Flex, Grid, Image, Stack, Title } from "@mantine/core";
import classNames from "classnames";
import type { ReactNode } from "react";
import { Link } from "react-router";
import DefaultLogoWhite from "../../assets/default/img/logo_white.png";
import { SiteName } from "../../utils/enums";
import { FooterMenu } from "./FooterMenu";
import "./PublicPageLayout.scss";
import { SiteLogo } from "./SiteLogo";

interface PublicPageLayoutProps {
  siteName: SiteName;
  children: ReactNode;
}

function PublicPageLayout({ children, siteName }: PublicPageLayoutProps) {
  return (
    <Grid className="PublicPageLayout" gap={0} h="100vh">
      <Grid.Col p="3rem" span={{ base: 12, md: 6 }}>
        <Stack h="100%" justify="center">
          <div className="login-logo">
            <Link to="/login">
              <SiteLogo siteName={siteName} />
            </Link>
          </div>
          {siteName === SiteName.Smarendo && (
            <div className="login-logo">
              <Title order={1}>SMARENDO</Title>
            </div>
          )}
          {children}
          <Flex justify="center">
            <FooterMenu siteName={siteName} />
          </Flex>
        </Stack>
      </Grid.Col>
      <Grid.Col
        className={classNames("login-background", {
          ["default-logo"]: siteName === SiteName.Optinode,
          ["smarendo-logo"]: siteName === SiteName.Smarendo
        })}
        p="4rem"
        span={{ base: 12, md: 6 }}
      >
        {siteName === SiteName.Optinode && (
          <Flex className="logo-text" h="100%" justify="center">
            <div>
              <Image
                alt="Optinode Logo"
                display="block"
                src={DefaultLogoWhite}
              />
              <p>&nbsp;</p>
              <p className="login-message">
                Mit opti.node lassen sich lokale Energiekonzepte ganz einfach
                planen, umsetzen und managen.
              </p>
            </div>
          </Flex>
        )}
      </Grid.Col>
    </Grid>
  );
}

export { PublicPageLayout };
